import React from 'react';
import { TAGS } from '@/data';

interface TagBadgeProps {
  tag: string;
  selected?: boolean;
  onClick?: () => void;
  small?: boolean;
}

export const TagBadge: React.FC<TagBadgeProps> = ({
  tag,
  selected,
  onClick,
  small
}) => {
  const tagData = TAGS.find(t => t.id === tag) || {
    label: tag,
    color: 'bg-zinc-500/20 text-zinc-400 border-zinc-500/30'
  };

  return (
    <button
      onClick={onClick}
      className={`${tagData.color} ${small ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm'} rounded-full border ${selected ? 'ring-2 ring-white/50' : ''}`}
    >
      {tagData.label}
    </button>
  );
};
